import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import { Upload } from "src/components/upload";
import cogoToast from "cogo-toast";
import { Stack } from "@mui/system";
import _ from "lodash";

class MultiUploadBox extends React.Component {
  state = {
    files: [],
    uploadedFiles: [],
    uploadingIndex: 0,
    uploadingProgress: 0,
    isUploading: false,
  };
  handleDropMultiFile = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );
    this.setState({ files: [...this.state.files, ...newFiles] });
  };
  handleRemoveFile = (inputFile) => {
    const filesFiltered = this.state.files.filter(
      (fileFiltered) => fileFiltered !== inputFile
    );
    this.setState({ files: filesFiltered });
  };
  handleRemoveAllFiles = () => {
    this.setState({ files: [] });
  };
  uploadMultipleFiles = async () => {
    let files = this.state.files;
    if (!files.length) {
      cogoToast.error("No files to upload");
    }
    this.setState({ isUploading: true });
    for (let i = 0; i < files.length; i++) {
      this.setState({
        uploadingIndex: i,
      });
      await this.uploadFile(files[i]);
    }
    this.setState({ isUploading: false }, () => {
      cogoToast.success("Files uploaded successfully");
      let uf = _.cloneDeep(this.state.uploadedFiles);
      this.setState({ uploadedFiles: [], files: [] }, () => {
        this.props.onUpload(uf);
      });
    });
  };
  uploadFile = async (file) => {
    try {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("threadId", this.props.threadId);
      let r = await this.props.apiCallPostUpload(
        "/harley/uploadFile",
        fd,
        (progress) => {
          this.setState({ uploadingProgress: progress });
        }
      );
      this.setState({
        uploadedFiles: [...this.state.uploadedFiles, r],
      });
    } catch (error) {
      console.log(error);
    }
  };
  renderIfUploading = () => {
    if (!this.state.isUploading) {
      return (
        <Upload
          acceptedFileTypes={this.props.acceptedFileTypes}
          thumbnail={true}
          multiple
          files={this.state.files}
          onDrop={this.handleDropMultiFile}
          onRemove={this.handleRemoveFile}
          onRemoveAll={this.handleRemoveAllFiles}
          onUpload={() => this.uploadMultipleFiles()}
        />
      );
    } else {
      return (
        <Stack spacing={2}>
          <Typography variant="overline">
            Uploading File {this.state.uploadingIndex + 1} of{" "}
            {this.state.files.length}: {this.state.uploadingProgress}% Complete
          </Typography>
          <LinearProgress
            variant="determinate"
            value={this.state.uploadingProgress}
          />
        </Stack>
      );
    }
  };
  render() {
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose}>
        <DialogTitle>Upload Files</DialogTitle>
        <DialogContent
          sx={{
            mb: 2,
          }}
        >
          {this.renderIfUploading()}
        </DialogContent>
      </Dialog>
    );
  }
}

export default WithAPICall(MultiUploadBox);
